export enum KpiActionTypes {
  FetchKpiMetric = 'kpi/fetchKpiMetric',
  FetchGroupedKpiMetric = 'kpi/fetchGroupedKpiMetric',
  FetchRevenueDistribution = 'kpi/fetchRevenueDistribution',
}

export enum MetadataActionTypes {
  FetchProductsRequest = 'metadata/fetchProductsRequest',
  FetchProductsSuccess = 'metadata/fetchProductsSuccess',
  FetchProductsFailure = 'metadata/fetchProductsFailure',
}
